import {createFeatureSelector} from "@ngrx/store";
import {CategoryState} from "./state";


export const selectCategory = createFeatureSelector<CategoryState>('category');
